import { type FC, useState } from 'react'
import { Modal } from '../../../components/Modal/Modal'
import { isIntakeReady } from '../domain/missingFields'
import { AccountTypeFields } from './AccountTypeFields'
import { useWizardFlow } from '../hooks/WizardFlowContext'
import { type WizardAccount } from '../domain/types'
import styles from '../AccountOpeningWizard.module.scss'

interface EditAccountDetailsModalProps {
  show: boolean
  account: WizardAccount
  onCancel: () => void
  onUpdate: (account: WizardAccount) => void
}

export const EditAccountDetailsModal: FC<EditAccountDetailsModalProps> = ({ show, account, onCancel, onUpdate }) => {
  const { ctx, accountTypes, selectors, contactOptions, defaultHolderName, defaultHolderContactId } = useWizardFlow()
  const [draft, setDraft] = useState<WizardAccount>(account)

  return (
    <Modal
      show={show}
      onHide={onCancel}
      size='lg'
      contentClassName={styles.formSurface}
      header={<h5 className='mb-0'>Edit account details</h5>}
      body={
        <AccountTypeFields
          accountTypes={accountTypes}
          selectors={selectors}
          account={draft}
          onChange={setDraft}
          connector={ctx.connector}
          contactOptions={contactOptions}
          defaultHolderName={defaultHolderName}
          defaultHolderContactId={defaultHolderContactId}
        />
      }
      showFooterActions
      footerPrimaryActionTitle='Update'
      footerPrimaryActionDisabled={!isIntakeReady(draft)}
      onFooterPrimaryAction={() => onUpdate(draft)}
      onFooterSecondaryAction={onCancel}
    />
  )
}
